import { gql } from 'urql';

export const GUIA_TIMELINE = gql`
  query GuiaTimeline($guia_id: Int!) {
    guiaTimeline(guia_id: $guia_id) {
      id
      sucursal_id
      guia_id
      tipo
      estado
      descripcion
      metadata_json
      usuario_id
      created_at
    }
  }
`;

export const ALERTAS_DASHBOARD = gql`
  query AlertasDashboard($sucursal_id: Int!, $limite: Int) {
    alertasDashboard(sucursal_id: $sucursal_id, limite: $limite) {
      id
      sucursal_id
      tipo
      referencia_tipo
      referencia_id
      severidad
      mensaje
      resuelta
      created_at
    }
  }
`;

export const RESOLVER_ALERTA = gql`
  mutation ResolverAlerta($input: ResolverAlertaInput!) {
    resolverAlerta(input: $input)
  }
`;

export const CAMBIAR_ESTADO_GUIA = gql`
  mutation CambiarEstadoGuia($input: CambiarEstadoGuiaInput!) {
    cambiarEstadoGuia(input: $input) {
      id
      numero
      estado
      sucursal_origen_id
      sucursal_destino_id
      sucursal_actual_id
      updated_at
      created_at
    }
  }
`;
